import sdl from '@jds/react-generated-sdl/JDSSidePanelInternal';
import type { JDSSidePanelInternalProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSSidePanelInternalProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    direction = 'left',
    showClose = true,
    open = false,
    maxWidth = false,
    disableTransition = false,
    suffixAriaLabel = 'Close Side Panel',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      direction,
      showClose,
      open,
      maxWidth,
      disableTransition,
      suffixAriaLabel,
      ...rest
    },
    'JDSSidePanelInternal',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const SidePanelInternal = withLogic(
  Component
) as React.FC<JDSSidePanelInternalProps> & { slotName?: string };

SidePanelInternal.displayName = 'SidePanelInternal';
SidePanelInternal.slotName = 'jds_side_panel_internal';

export { SidePanelInternal, type JDSSidePanelInternalProps };
